<template>
  <div class="modal-chat" v-if="modal">
    <div class="modal-chat-content">

      <button class="btn-close" @click="closeModal" title="Fechar Chat">
        <i class="fa fa-times"></i>
      </button>

      <div class="box-iframe" v-if="src">
        <iframe :src="src" frameborder="0"></iframe>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ModalChat",

  data() {
    return {
      modal: false,
      src: null,
      token: localStorage.getItem("token")
    };
  },

  methods: {
    closeModal() {
      this.modal = false;
      document.body.classList.remove("modal-open");
    },

    openModal(id_pedido) {
      if (!id_pedido || !this.token) return;

      this.modal = true;
      const base = ['3','4'].includes((this.envEmpresa || {}).VUE_APP_AMBIENTE) ? 'hhh.chat' : 'chat';
      this.src = `https://${base}.lecard.delivery/pedido/${id_pedido}?t=${this.token}`;
      document.body.classList.add("modal-open");

      setTimeout(() => {
        document.documentElement.style.setProperty(
            "--vh",
            `${window.innerHeight * 0.01}px`
        );
      }, 10);
    },

    updateVH() {
      document.documentElement.style.setProperty(
          "--vh",
          `${window.innerHeight * 0.01}px`
      );
    }
  },

  mounted() {
    this.updateVH();
    window.addEventListener("resize", this.updateVH);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateVH);
  }
};
</script>

<style scoped>
/* trava o body */
.modal-open {
  overflow: hidden;
}

/* fundo da modal + animação */
.modal-chat {
  position: fixed;
  inset: 0;
  z-index: 9990;

  background: rgba(0, 0, 0, 0.45);
  animation: fadeIn .25s ease-out;

  display: flex;
  justify-content: center;
  align-items: flex-start;

  padding: env(safe-area-inset-top) 0 env(safe-area-inset-bottom);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* caixa principal da modal */
.modal-chat-content {
  background: #fff;
  border-radius: 12px;

  width: 95%;
  max-width: 900px;

  /* iOS FIX -> usa var(--vh) ao invés de vh */
  height: calc(var(--vh, 1vh) * 100 - 40px);

  margin-top: 20px;
  position: relative;
  overflow: hidden;

  animation: slideUp .25s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* botão fechar */
.btn-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 44px;
  height: 44px;

  border-radius: 50%;
  border: none;
  background: #f0f2f5;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  z-index: 10;
}

/* iframe container */
.box-iframe {
  width: 100%;
  height: 100%;
}

.box-iframe iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  background: #fff;
}
</style>
